import { React, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { tagFunctions, isTagged } from './Tags'

function TagLinks() {

  const restaurants = useSelector((state)=>state.firestore.ordered.restaurants);
  const [tagList, setTagList] = useState([]);

useEffect(()=>{
	console.log('restaurants')
	console.log(restaurants)
	var tags = [];
	var tagList2 = [];
	if(restaurants){
		tags = tagFunctions.compileTags(restaurants);
    for(var tag in tags){
      tagList2.push(
      tags[tag]["value"]
      )
    }
    setTagList(tagList2)
	}
},[restaurants])

useEffect(()=>{
	console.log('tagList');
  console.log(tagList);
  let isTag = false;
  if(restaurants && tagList.length>1){
  	let count = 0;
  	for(let rest in restaurants){
	  	isTag = isTagged(restaurants[rest], [{value:tagList[0],label:tagList[0]}])
	  	console.log(restaurants[rest])
	  	console.log(isTag)
	  	console.log(tagList[0])
	  	console.log([{value:tagList[0],label:tagList[0]}])
	  	if(isTag){
	  		count = count + 1;
	  	}	
  	}
  	
	 console.log('count')
	 console.log(count)	
  }
},[tagList])
  

  return (
    <>
      <div style={{display:"flex", flexFlow:"row", justifyContent:"space-around"}}>
        
      </div>
    </>
  );
}

export default TagLinks;